import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  container: {
    padding: theme.spacing(3),
  },
  filtersCard: {
    marginBottom: theme.spacing(3),
  },
  filtersContent: {
    display: 'flex',
    gap: theme.spacing(2),
    flexWrap: 'wrap',
    alignItems: 'flex-end',
  },
  filterField: {
    minWidth: 200,
  },
  tabContent: {
    padding: theme.spacing(3),
  },
  summaryCard: {
    height: '100%',
    transition: 'all 0.3s ease',
    '&:hover': {
      transform: 'translateY(-4px)',
      boxShadow: '0 8px 16px rgba(0,0,0,0.15)',
    },
  },
  summaryValue: {
    fontSize: '2rem',
    fontWeight: 600,
    color: theme.palette.primary.main,
  },
  summaryLabel: {
    fontSize: '0.875rem',
    color: theme.palette.text.secondary,
    marginTop: theme.spacing(1),
  },
  statusGrid: {
    marginTop: theme.spacing(3),
  },
  chartContainer: {
    height: 300,
    marginTop: theme.spacing(3),
  },
  exportButton: {
    marginLeft: 'auto',
  },
  tableContainer: {
    marginTop: theme.spacing(2),
  },
  profitPositive: {
    color: theme.palette.success.main,
    fontWeight: 600,
  },
  profitNegative: {
    color: theme.palette.error.main,
    fontWeight: 600,
  },
  expandIcon: {
    transition: 'transform 0.3s',
  },
  expandIconOpen: {
    transform: 'rotate(180deg)',
  },
  nestedTable: {
    backgroundColor: theme.palette.grey[50],
  },
}));
